import React from "react"

function Loader() {
    return (
        <div className="d-flex fill-screen justify-content-center">
            <div
                className="spinner-border spinner-settings my-auto loader"
                role="status"
            >
                <span className="visually-hidden my-auto">Loading...</span>
            </div>
        </div>
    )
}

export default Loader
